import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ClaimType.Delete.IRequest;
type Response = Api.Core.ClaimType.Delete.IResponse;
type Headers = Api.Core.ClaimType.Delete.IHeaders;
const url = '/api/Claims/ClaimType/:id';
export default async function claimTypeDeleteApi(id: number): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.delete,
    url: createPathFromRoute(url, { id }),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
